import React from 'react';
import { Binary, Code, Database, Cloud, Globe, Cpu, Server, Network, BookOpen, TrendingUp, Shield, Terminal } from 'lucide-react';
import PageTitle from '../components/PageTitle';

function TechStack() {
  // Keep all existing content...

  const security = [
    {
      title: "Zero Trust Architecture",
      source: "NIST",
      quote: "Zero Trust security models are becoming the standard for enterprise security architecture",
      link: "https://www.nist.gov"
    },
    {
      title: "DevSecOps Integration",
      source: "Gartner",
      quote: "By 2025, 70% of enterprises will implement DevSecOps practices for security integration",
      link: "https://www.gartner.com"
    }
  ];

  const emerging = [
    {
      title: "Web3 Technologies",
      items: [
        "Decentralized applications (dApps)",
        "Smart contract development",
        "Blockchain integration",
        "Cryptocurrency implementations"
      ]
    },
    {
      title: "Extended Reality (XR)",
      items: [
        "AR/VR development",
        "Mixed reality applications",
        "3D visualization",
        "Spatial computing"
      ]
    }
  ];

  const performance = [
    {
      title: "Application Performance",
      source: "New Relic",
      quote: "Organizations implementing observability see 60% faster mean time to resolution",
      link: "https://newrelic.com"
    },
    {
      title: "Cloud Cost Optimization",
      source: "AWS",
      quote: "Proper cloud architecture can reduce infrastructure costs by up to 50%",
      link: "https://aws.amazon.com"
    }
  ];

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      {/* Keep existing PageTitle and header section */}
      
      {/* Keep existing categories grid */}
      
      {/* Keep existing trends section */}
      
      {/* Keep existing resources section */}

      {/* Add new Security section */}
      <div className="bg-white rounded-lg shadow-md p-8 mb-8">
        <h2 className="text-2xl font-bold mb-6 flex items-center">
          <Shield className="w-6 h-6 text-[#EC6224] mr-2" />
          Security & Compliance
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {security.map((item, index) => (
            <div key={index} className="bg-gray-50 rounded-lg p-6">
              <h3 className="text-xl font-semibold mb-2">{item.title}</h3>
              <blockquote className="border-l-4 border-[#EC6224] pl-4 italic text-gray-600 mb-4">
                "{item.quote}"
              </blockquote>
              <p className="text-sm text-gray-500">
                Source:{' '}
                <a
                  href={item.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#EC6224] hover:text-[#232323]"
                >
                  {item.source}
                </a>
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* Add new Emerging Technologies section */}
      <div className="bg-white rounded-lg shadow-md p-8 mb-8">
        <h2 className="text-2xl font-bold mb-6 flex items-center">
          <Globe className="w-6 h-6 text-[#EC6224] mr-2" />
          Emerging Technologies
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {emerging.map((tech, index) => (
            <div key={index} className="border-l-4 border-[#EC6224] pl-4">
              <h3 className="text-xl font-semibold mb-4">{tech.title}</h3>
              <ul className="space-y-2">
                {tech.items.map((item, idx) => (
                  <li key={idx} className="text-gray-700">• {item}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      {/* Add new Performance Optimization section */}
      <div className="bg-white rounded-lg shadow-md p-8">
        <h2 className="text-2xl font-bold mb-6 flex items-center">
          <Terminal className="w-6 h-6 text-[#EC6224] mr-2" />
          Performance & Optimization
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {performance.map((item, index) => (
            <div key={index} className="bg-gray-50 rounded-lg p-6">
              <h3 className="text-xl font-semibold mb-2">{item.title}</h3>
              <blockquote className="border-l-4 border-[#EC6224] pl-4 italic text-gray-600 mb-4">
                "{item.quote}"
              </blockquote>
              <p className="text-sm text-gray-500">
                Source:{' '}
                <a
                  href={item.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#EC6224] hover:text-[#232323]"
                >
                  {item.source}
                </a>
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default TechStack;